import CustomerModel from '../../../../../view/pages/posm/models/Customer.model';
import { CustomerService } from '../../../customers';

export default {
  namespaced: true,
  state: {
    customers: [],
    businessCustomers: [],
    paginations: {
      total: 0,
      totalPages: 0,
      currentPage: 1,
    },
    businessPaginations: {
      total: 0,
      totalPages: 0,
      currentPage: 1,
    },
    currentCustomer: null,
    currentBusinessCustomer: null,
    loading: false,
    error: null,
  },
  getters: {
    getCustomers: (state) => state.customers,
    getBusinessCustomers: (state) => state.businessCustomers,
    getCurrentCustomer: (state) => state.currentCustomer,
    getCurrentBusinessCustomer: (state) => state.currentBusinessCustomer,
    getPaginations: (state) => state.paginations,
    getBusinessPaginations: (state) => state.businessPaginations,
    isLoading: (state) => state.loading,
    getError: (state) => state.error,
  },
  mutations: {
    SET_CUSTOMERS(state, { data, paginations }) {
      state.customers = data;
      state.paginations = paginations;
    },
    SET_BUSINESS_CUSTOMERS(state, { data, paginations }) {
      state.businessCustomers = data;
      state.businessPaginations = paginations;
    },
    SET_CURRENT_CUSTOMER(state, customer) {
      state.currentCustomer = customer;
    },
    SET_CURRENT_BUSINESS_CUSTOMER(state, customer) {
      state.currentBusinessCustomer = customer;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
  },
  actions: {
    async fetchCustomers({ commit }, params) {
      commit('SET_LOADING', true);
      try {
        const { data } = await CustomerService.getAll(params);
        const customers = CustomerModel.fromJsonArray(data?.data.data);
        const paginations = data?.data.paginations;
        commit('SET_CUSTOMERS', {
          data: customers,
          paginations,
        });
        return {
          data: customers,
          paginations,
        };
      } catch (error) {
        console.log(error);
        commit('SET_ERROR', error);
      } finally {
        commit('SET_LOADING', false);
      }
    },

    async fetchCustomerById({ commit }, id) {
      commit('SET_LOADING', true);
      try {
        const { data } = await CustomerService.getById(id);
        const customer = CustomerModel.fromJson(data.data);
        commit('SET_CURRENT_CUSTOMER', customer);
        return customer;
      } catch (error) {
        commit('SET_ERROR', error);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    async createCustomer({ commit }, data) {
      commit('SET_LOADING', true);
      try {
        const response = await CustomerService.create(data);
        const customer = CustomerModel.fromJson(response.data.data);
        return customer;
      } catch (error) {
        commit('SET_ERROR', error);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    async updateCustomer({ commit }, { id, data }) {
      commit('SET_LOADING', true);
      try {
        const response = await CustomerService.update(id, data);
        const customer = CustomerModel.fromJson(response.data.data);
        return customer;
      } catch (error) {
        commit('SET_ERROR', error);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    async deleteCustomer({ commit }, id) {
      commit('SET_LOADING', true);
      try {
        await CustomerService.delete(id);
      } catch (error) {
        commit('SET_ERROR', error);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    /**
     *
     * @param {Object} vuex context
     * @param {Object} params
     * @param {string|undefined} params.keyword
     * @param {number} params.limit
     * @param {number} params.page
     * @returns
     */
    async smartSearch({ commit }, params) {
      try {
        const { data } = await CustomerService.smartSearch(params);
        return {
          data: CustomerModel.fromJsonArray(data?.data.data),
          paginations: data?.data.paginations,
        };
      } catch (error) {
        commit('SET_ERROR', error);
        return {
          data: [],
          paginations: {
            total: 0,
            totalPages: 0,
            currentPage: 1,
          },
        };
      }
    },

    // Business customer actions
    async fetchBusinessCustomers({ commit }, params) {
      commit('SET_LOADING', true);
      try {
        const { data } = await CustomerService.getBusinessCustomers(params);
        commit('SET_BUSINESS_CUSTOMERS', {
          data: CustomerModel.fromJsonArray(data.data.data),
          paginations: data.data.paginations,
        });
      } catch (error) {
        console.log(error);
        commit('SET_ERROR', error);
      } finally {
        commit('SET_LOADING', false);
      }
    },

    async fetchBusinessCustomerById({ commit }, id) {
      commit('SET_LOADING', true);
      try {
        const { data } = await CustomerService.getBusinessCustomerById(id);
        const customer = CustomerModel.fromJson(data.data);
        commit('SET_CURRENT_BUSINESS_CUSTOMER', customer);
        return customer;
      } catch (error) {
        commit('SET_ERROR', error);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    async createBusinessCustomer({ commit }, data) {
      commit('SET_LOADING', true);
      try {
        const response = await CustomerService.createBusinessCustomer(data);
        return response.data;
      } catch (error) {
        commit('SET_ERROR', error);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    async updateBusinessCustomer({ commit }, { id, data }) {
      commit('SET_LOADING', true);
      try {
        const response = await CustomerService.updateBusinessCustomer(id, data);
        return response.data;
      } catch (error) {
        commit('SET_ERROR', error);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    async deleteBusinessCustomer({ commit }, id) {
      commit('SET_LOADING', true);
      try {
        await CustomerService.deleteBusinessCustomer(id);
      } catch (error) {
        commit('SET_ERROR', error);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },
  },
};
